import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import { readToken } from '../../lib/sanity.api'
import { getCityBySlug, getClient } from '../../lib/sanity.client'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { Location } from '../../components/location/Location'

interface CityProps {
  city: MajorLocation
}

const CityPage: NextPage<CityProps> = ({ city }: CityProps) => {
  return <Location location={city} />
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params, preview, locale } = context
  const { city: citySlug } = params
  const client = getClient(preview ? { token: readToken } : undefined)
  const [city, translations] = await Promise.all([
    getCityBySlug(locale as AppLocale, client, citySlug as string),
    serverSideTranslations(locale, ['common']),
  ])

  if (!city) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      ...translations,
      city,
    },
  }
}

export default CityPage
